const data = {
    article_package_id: 1,
    attachment: null,
    deadline: "",
    description: "",
    qty: 5,
    reference: "",
}

const packages = {
    starter:{
        editor_review: "Tidak",
        revision: "1x",
        image: "Tidak",
        article_package_id: {
            indonesia: 1,
            inggris: 4
        },
        indonesia: 35000,
        inggris: 85000,
    },
    regular:{
        editor_review: "Iya",
        revision: "2x",
        image: "Tidak",
        article_package_id: {
            indonesia: 2,
            inggris: 5
        },
        indonesia: 50000,
        inggris: 100000,
    },

}

export function articlesReducer(state = {
    packages,
    data,
    isCreateSuccess: false
},action){
    switch(action.type){
        case "SET_ARTICLES_PACKAGE":
            data.article_package_id = packages[action.package].article_package_id[action.languange]
            return Object.assign({}, state, {
                data
            })
        case "ORDER_ARTICLES":
            data[action.name] = action.value
            return Object.assign({}, state, {
                data,
                isCreateSuccess: false
            })
        case "CREATE_ARTICLES_FULFILLED":
            return Object.assign({},state,{
                isCreateSuccess: true
            })
        case "CREATE_ARTICLES_PENDING":
            return Object.assign({},state,{
                isCreateSuccess: false
            })
        default:
            return state
    }
}


export function articlesCreate(state = {
    isPending: false,
    isCreateSuccess: false
},action){
    switch(action.type){
        case "ORDER_ARTICLES_RESET":
            data[action.name] = action.value
            return Object.assign({}, state, {
                isPending: false,
                isCreateSuccess: false
            })
        case "CREATE_ARTICLES_FULFILLED":
            return Object.assign({},state,{
                isCreateSuccess: true,
                isPending: false
            })
        case "CREATE_ARTICLES_PENDING":
            return Object.assign({},state,{
                isCreateSuccess: false,
                isPending: true,
            })
        default:
            return state
    }
}

export function articlesOrders(state = {
    data: [],
    links: {},
    isPending: false,
}, action){
    switch(action.type){
        case "GET_ORDERS_ARTICLES_FULFILLED":
            return Object.assign({}, state, {
                data:  action.payload.data.results.meta.current_page === 1 ?
                action.payload.data.results.data : 
                state.data.concat(action.payload.data.results.data),
                links: action.payload.data.results.links,
                isPending: false,
            })
        case "GET_ORDERS_ARTICLES_PENDING":
            return Object.assign({}, state, {
                isPending: false
            })
        default: 
            return state
    }
}

export function articlesOrdersDetail(state = {
    data: {},
    isPending: true,
}, action){
    switch(action.type){
        case "GET_ORDERS_ARTICLES_DETAIL_FULFILLED":
            return Object.assign({}, state, {
                data: action.payload.data.results.data,
                isPending: false,
            })
        case "GET_ORDERS_ARTICLES_DETAIL_PENDING":
            return Object.assign({}, state, {
                data: {},
                isPending: true
            })
        default: 
            return state
    }
}